import * as React from "react";
import { Alert, AlertTitle, Button, Stack } from "@mui/material";

interface ErrorPanelProps {
  message: string;
  onRetry?: () => void;
}

/** Displays a backend/network failure with an optional retry action. Never crashes the page. */
export function ErrorPanel({ message, onRetry }: ErrorPanelProps): React.JSX.Element {
  return (
    <Alert severity="error" role="alert">
      <AlertTitle>Unable to load data</AlertTitle>
      <Stack spacing={1} alignItems="flex-start">
        <span>{message}</span>
        {onRetry ? (
          <Button size="small" variant="outlined" color="error" onClick={onRetry}>
            Retry
          </Button>
        ) : undefined}
      </Stack>
    </Alert>
  );
}
